import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query/types/react/types";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import type { ShortCodeProvider } from "src/numbers/objects/ShortCodeProvider";
import { useApiGet } from "src/shared/actions/FetchActions";

export const useShortCodeProviders = (
  countryCode: string,
  options?: UseQueryOptions<
    ShortCodeProvider[],
    unknown,
    ShortCodeProvider[],
    ["shortCodeProviders", string]
  >,
) => {
  const apiGet = useApiGet();
  return useQuery(
    ["shortCodeProviders", countryCode],
    async () => {
      const { data } = await apiGet<ShortCodeProvider[]>(
        `${UTILS_API_PATH}/providers/CSC/${countryCode}`,
      );
      return data;
    },
    options,
  );
};
